import type { ReactNode } from "react";
import { useRef } from "react";
import { useVideoAnalytics } from "@/react/components/AnalyticsTracker/useVideoAnalytics";

export interface MediaElementProps {
  children: ReactNode;
  contentType: string;
  id: string;
  poster?: string;
  preload?: "none" | "metadata" | "auto";
  signedId: string;
}

export const MediaElement = ({
  id,
  contentType,
  children,
  poster,
  preload = "none",
  signedId,
}: MediaElementProps) => {
  // eslint-disable-next-line sonarjs/prefer-regexp-exec -- Disabled for plugin version update. Fix when possible
  const isAudioMode = contentType?.match("audio.*");
  const videoRef = useRef<HTMLVideoElement>(null);
  useVideoAnalytics(videoRef, signedId);

  if (isAudioMode) {
    return (
      <audio id={id} preload={preload} controls>
        {children}
      </audio>
    );
  }

  return (
    <video
      id={id}
      preload={preload}
      controls
      poster={poster}
      data-poster={poster}
      data-testid="media-player"
      ref={videoRef}
    >
      {children}
    </video>
  );
};
